import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import AOS from "aos";
import React from "react";
import SeoMetadata from "./components/SeoMetadata";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
import StickyHeader from "./components/StickyHeader";
import SidebarOne from "./components/SidebarOne";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Solutions from "./pages/Solutions";
import Gallery from "./pages/Gallery";

import "./App.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "jquery-ui-dist/jquery-ui.css";
import "react-datepicker/dist/react-datepicker.css";
import "jarallax/dist/jarallax.css";
import "magnific-popup/dist/magnific-popup.css";
import "tiny-slider/dist/tiny-slider.css";
import "slick-carousel/slick/slick.css";
import "aos/dist/aos.css";
import "owl.carousel/dist/assets/owl.carousel.min.css";
import "owl.carousel/dist/assets/owl.theme.default.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "./assets/vendors/bootstrap/css/bootstrap.min.css";
import "./assets/vendors/bootstrap-select/bootstrap-select.min.css";
import "./assets/vendors/animate/animate.min.css";
import "./assets/vendors/fontawesome/css/all.min.css";
import "./assets/vendors/jquery-ui/jquery-ui.css";
import "./assets/vendors/date-time-picker/jquery.datetimepicker.min.css";
import "./assets/vendors/jarallax/jarallax.css";
import "./assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css";
import "./assets/vendors/nouislider/nouislider.min.css";
import "./assets/vendors/nouislider/nouislider.pips.css";
import "./assets/vendors/tiny-slider/tiny-slider.css";
import "./assets/vendors/lotech-icons/style.css";
import "./assets/vendors/slick/slick.css";
import "./assets/vendors/aos/aos.css";
import "./assets/vendors/owl-carousel/css/owl.carousel.min.css";
import "./assets/vendors/owl-carousel/css/owl.theme.default.min.css";
import "./theme-dark.css";
import loaderImage from "./assets/loader.png";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  useEffect(() => {
    const togglers = document.querySelectorAll(
      ".topbar__toggler, .main-header__toggler"
    );

    togglers.forEach((btn) => {
      btn.addEventListener("click", openSidebar);
    });

    return () => {
      togglers.forEach((btn) => {
        btn.removeEventListener("click", openSidebar);
      });
    };
  }, []);

  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    AOS.init({
      offset: 120,
      duration: 800,
      easing: "ease-in-out",
      delay: 100,
    });
  }, []);

  useEffect(() => {
    const cursor = document.querySelector(".custom-cursor__cursor");
    const cursorTwo = document.querySelector(".custom-cursor__cursor-two");

    document.addEventListener("mousemove", (e) => {
      cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      cursorTwo.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    });

    return () => {
      document.removeEventListener("mousemove", () => {});
    };
  }, []);

  return (
    <div className="App">
      {/* <SmoothScroll /> */}
      {loading && (
        <div className="preloader">
          <img
            src={loaderImage}
            alt="Loading..."
            className="preloader__image"
          />
        </div>
      )}

      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      {!loading && (
        <Router>
          <SeoMetadata />
          <ScrollToTopOnRouteChange />
          <ScrollToTop />
          <StickyHeader />
          <SidebarOne isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/gallery" element={<Gallery />} />
            {/* Legacy URLs redirect into the consolidated Solutions page */}
            <Route path="/services" element={<Navigate to="/solutions" replace />} />
            <Route path="/products" element={<Navigate to="/solutions" replace />} />
            <Route path="/managed-it-services" element={<Navigate to="/solutions#managed-it-cloud" replace />} />
            <Route path="/erp-solutions" element={<Navigate to="/solutions#erp" replace />} />
            <Route path="/odoo-erp" element={<Navigate to="/solutions#erp" replace />} />
            <Route path="/hr-management-solutions" element={<Navigate to="/solutions#erp" replace />} />
            <Route path="/software-solutions" element={<Navigate to="/solutions#software-dev" replace />} />
            <Route path="/app-development" element={<Navigate to="/solutions#software-dev" replace />} />
            <Route path="/web-development" element={<Navigate to="/solutions#software-dev" replace />} />
            <Route path="/cloud-solutions" element={<Navigate to="/solutions#managed-it-cloud" replace />} />
            <Route path="/cross-platform-db-synchronization" element={<Navigate to="/solutions#integration" replace />} />
            <Route path="/intelligent-video-analytics" element={<Navigate to="/solutions#ai-surveillance" replace />} />
            <Route path="/terminal-service-plus" element={<Navigate to="/solutions#bpo" replace />} />
            <Route path="/digital-marketing-services" element={<Navigate to="/solutions" replace />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp />
        </Router>
      )}
    </div>
  );
}

export default App;
